// extracted by mini-css-extract-plugin
module.exports = {"table":"ParamTable_table__CHl8y"};